const routers = [
    {
        path: '/',
        meta: {
            title: '首页'
        },
        component: (resolve) => require(['./views/index.vue'], resolve)
    },
    {
        path: '/control/',
        meta: {
            title: '实时监测'
        },
        component: (resolve) => require(['./views/control.vue'], resolve)
    },
    {
        path: '/control/:province/:city/:county/:device_name/',
        meta: {
            title: '实时监测'
        },
        component: (resolve) => require(['./views/control.vue'], resolve)
    },
    {
        path: '/history/',
        meta: {
            title: '历史数据'
        },
        component: (resolve) => require(['./views/history.vue'], resolve)
    },
    {
        path: '/history/:province/:city/:county/:device_name/',
        meta: {
            title: '历史数据'
        },
        component: (resolve) => require(['./views/history.vue'], resolve)
    }
];
export default routers;